// Age-bracket prices as shown to the customer (slot cards, price box, reservation summary)

// Display order: adults first, then the brackets that usually pay less
export const AGE_BRACKET_ORDER = ['Adult', 'Senior', 'TwelveToSeventeen', 'SixToEleven', 'ZeroToFive'];

// The brackets an experience prices, in display order: [{ key, price }]
export function pricedAgeBrackets(prices) {
  if (!prices) return [];
  return AGE_BRACKET_ORDER
    .filter(key => prices[key] !== undefined && prices[key] !== null)
    .map(key => ({ key, price: Number(prices[key]) }));
}

export function formatEuro(value, locale) {
  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(value || 0);
}
